import { StrictMode } from 'react'
import './i18n'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import { injectPwaIcons } from './hooks/usePwaIcon'

// Gera e injeta os ícones PWA com degradê cinza claro + logo original
injectPwaIcons();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
